import React from 'react';

export default function Footer() {
  return (
    <footer className="flex-shrink-0 text-sm font-semibold  bg-red-700 text-white p-1 h-auto w-full flex justify-center items-center">
      Website designed by: Joshua Rieth
    </footer>
  );
}
